import * as actionTypes from './actionTypes';
import { serviceAnnouncementDetail } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { fetchValidate } from '@app/src/common/session';

const fetchAnnouncementDetailRequest = () => ({
  type: actionTypes.FETCH_ANNOUNCEMENT_DETAIL_REQUEST
});

const fetchAnnouncementDetailSuccess = (data) => ({
  type: actionTypes.FETCH_ANNOUNCEMENT_DETAIL_SUCCESS,
  data
});

const fetchAnnouncementDetailFailure = () => ({
  type: actionTypes.FETCH_ANNOUNCEMENT_DETAIL_FAILURE
});

export const fetchAnnouncementDetail = (categoryId: number, uniqueId: string): Function => {
  return async dispatch => {
    dispatch(fetchAnnouncementDetailRequest());
    await dispatch(fetchValidate());
    try {
      const data = await serviceAnnouncementDetail.get(categoryId, uniqueId);
      dispatch(fetchAnnouncementDetailSuccess(data));
    } catch (e) {
      dispatch(fetchAnnouncementDetailFailure());
      dispatch(actionsModalError.openModalError());
    }
  }
};
